import 'rxjs/add/operator/toPromise';
import { Subject } from 'rxjs';
import * as i0 from "@angular/core";
var ResetService = /** @class */ (function () {
    function ResetService() {
        // Subject único y compartido: permite que varios servicios (client-service,
        // policy-service, …) se suscriban al logout. Antes se recreaba en cada
        // observerLogout(), por lo que solo el último suscriptor recibía el evento.
        this.logoutChange = new Subject();
    }
    ResetService.prototype.observerLogout = function () {
        return this.logoutChange.asObservable();
    };
    ResetService.prototype.logout = function (token) {
        this.logoutChange.next(token);
    };
    ResetService.ngInjectableDef = i0.defineInjectable({ factory: function ResetService_Factory() { return new ResetService(); }, token: ResetService, providedIn: "root" });
    return ResetService;
}());
export { ResetService };
